export default "__VITE_ASSET__B6V89yWp__"